export enum CurrencyActionsType {
    GET_CURRENCY = 'GET_CURRENCY',
    GET_CURRENCY_SUCCESS = 'GET_CURRENCY_SUCCESS',
    GET_CURRENCY_FAIL = 'GET_CURRENCY_FAIL'
}